import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(() => ({
	tag: {
		"& svg": {
			height: 40
		}
	}
}));

export default styles;
